module.exports = __webpack_public_path__ + "img/imovel-render-1.8dd58a02.svg";